import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

export const TabBar = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.border.color.medium};
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  gap: 0;
`;

interface TabProps {
  active?: boolean;
}

export const Tab = styled('button', {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'active'
})<TabProps>`
  padding: ${({ theme }) => theme.spacing(2, 4)};
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-family: ${({ theme }) => theme.font.family};
  color: ${({ active, theme }) =>
    active ? theme.accent.primary : theme.font.color.tertiary};
  background: none;
  border: none;
  border-bottom: 2px solid ${({ active, theme }) =>
    active ? theme.accent.primary : 'transparent'};
  cursor: pointer;
  transition: ${({ theme }) => theme.animation.transition.color};
  margin-bottom: -1px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent.primary};
    outline-offset: 2px;
  }

  &:hover {
    color: ${({ theme }) => theme.font.color.primary};
  }
`;

export const TabContent = styled.div``;
